import React from 'react';
import { PageSpinner } from '@/components/Spinner/PageSpinner';

export const LoadingOverlay: React.FC = () => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/60">
    <PageSpinner className="size-[20px] text-subtle-foreground" />
  </div>
);
